module.exports = __webpack_public_path__ + "img/6_88.61b3f28c.png";